export default function formatNum(num) {
    var fmt = 10000;
    var result = parseFloat(num);

    if (isNaN(result)) {

        console.log('���ݲ����������飡');

        return false;

    }

    result = Math.round(num * fmt) / fmt;

    return result;

};
